export default __webpack_public_path__ + "static/media/tow-car.4210066f.svg";